<template>
    <div class="chat-item-lote-lista scroll-y overflow-x-hidden px-2">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ChatItemLoteLista'
}
</script>

<style scoped lang="stylus">
    .chat-item-lote-lista
        background-color white
        height calc(100vh - 350px) !important
</style>